<template>
  <div>
    <div class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="onSave">{{locale.save}}</button>
    </div>
    <div class="innerItem">
      <router-link to="/localinfo/create" class="btn btnFull">{{locale.localinfo_created}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale'
  ],
  computed: {
    display () {
      return this.$store.getters['localinfo/getDisplay']
    },
    recommend () {
      return this.$store.getters['localinfo/getRecommend']
    }
  },
  methods: {
    validateOnSave () {
      return true
    },
    onSave () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        // if (changeDisplay && window.confirm(this.locale.confirm_modify_localinfo)) {
        //   this.$store.commit('onLoading', true)
        //   this.$store.dispatch('localinfo/setVisible').then((res) => {
        //     alert(this.locale.complete_save)
        //     this.$store.commit('localinfo/initDisplay')
        //     this.$store.dispatch('localinfo/getLocalList').then(() => {
        //       this.$store.commit('onLoading', false)
        //     })
        //   })
        // }
        if (window.confirm(this.locale.confirm_modify_localinfo)) {
          this.$store.commit('onLoading', true)
          this.$store.dispatch('localinfo/updateLocalinfo').then((res) => {
            alert(this.locale.complete_save)
            this.$store.commit('localinfo/initDisplay')
            this.$store.dispatch('localinfo/getLocalList').then(() => {
              this.$store.commit('onLoading', false)
            })
          })
        }
      }
    }
  }
}
</script>
